module.exports = __webpack_public_path__ + "static/media/Scooter.d7e2d360.svg";